import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, switchMap, take } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { selectPaymentAuthRequest } from 'src/app/feature/payment/payment.selectors';
import { ApiServiceBase } from './api-base.service';
import { Response } from './api.interface';
import { PAYMENT_AUTH_ENDPOINT, PaymentAuthResponse } from './responses/payment-auth';

@Injectable({
  providedIn: 'root',
})
export class ApiService extends ApiServiceBase {
  constructor(http: HttpClient, private store: Store<AppState>) {
    super(http, store);
  }

  /**
   * This endpoint should be called to authorize any payment method processed through AccessoPay.
   * This API can accept an array of payments which will be authorized in order.
   */
  public paymentAuth(): Observable<Response<PaymentAuthResponse>> {
    return this.store.select(selectPaymentAuthRequest).pipe(
      take(1),
      switchMap((request) => {
        return this.post<PaymentAuthResponse>(PAYMENT_AUTH_ENDPOINT, request);
      })
    );
  }
}
